module.exports = __webpack_public_path__ + "img/additive-technology.e604f979.png";